module.exports = __webpack_public_path__ + "static/img/JM.6cb11ed9.svg";